import { defineMessages } from 'react-intl';

export default defineMessages({
  resendCodeWait: {
    id: 'LOGIN_RESEND_CODE_WAIT',
    defaultMessage:
      'Bitte warten Sie noch {countdown} Sekunden auf den Erhalt des Codes.',
  },
  resendCodeSend: {
    id: 'LOGIN_RESEND_CODE_SEND',
    defaultMessage: 'Code nicht erhalten? {link}.',
  },
  resendCodeSendLink: {
    id: 'LOGIN_RESEND_CODE_SEND_LINK',
    defaultMessage: 'Erneut senden',
  },
  resendLinkWait: {
    id: 'LOGIN_RESEND_LINK_WAIT',
    defaultMessage:
      'Bitte warten Sie noch {countdown} Sekunden auf den Erhalt des Links.',
  },
  resendLinkSend: {
    id: 'LOGIN_RESEND_LINK_SEND',
    defaultMessage: 'Link nicht erhalten? {link}.',
  },
  resendLinkSendLink: {
    id: 'LOGIN_RESEND_LINK_SEND_LINK',
    defaultMessage: 'Erneut senden',
  },
});
